export default __webpack_public_path__ + "static/media/linha-fala.2a233bff.png";